export const TREND_CHART_MOCK_DATA = [
  {
    date: 'Apr 24',
    line1: 90,
    line2: 30,
    line3: 20,
  },
  {
    date: 'Apr 25',
    line1: 70,
    line2: 40,
    line3: 30,
  },
  {
    date: 'Apr 26',
    line1: 57,
    line2: 55,
    line3: 50,
  },
  {
    date: 'Apr 27',
    line1: 60,
    line2: 45,
    line3: 55,
  },
  {
    date: 'Apr 28',
    line1: 80,
    line2: 50,
    line3: 40,
  },
  {
    date: 'Apr 29',
    line1: 70,
    line2: 60,
    line3: 50,
  },
];

export const TREND_CHART_MOCK_LINES = [
  { key: 'line1', color: '#BEE092', name: 'Line 1' },
  { key: 'line2', color: '#70C7EB', name: 'Line 2' },
  { key: 'line3', color: '#AF82FF', name: 'Line 3' },
];

export const DISTRIBUTION_CHART_MOCK_DATA = [
  { name: 'name1', value: 38 },
  { name: 'name2', value: 48 },
  { name: 'name3', value: 72 },
  { name: 'name4', value: 99 },
  { name: 'name5', value: 72 },
  { name: 'name6', value: 84 },
];
export const BAR_CHART_MOCK_DATA = [
  { name: 'Product department', value: 100 },
  { name: 'Design department', value: 50 },
  { name: 'Technical department', value: 15 },
  { name: 'Marketing department', value: 63 },
  { name: 'Sales department', value: 63 },
  { name: 'Executive department', value: 75 },
];

export const IMPROVEMENT_CHART_MOCK_DATA = [
  {
    name: 'My work-life balance is manageable',
    currentValue: 100,
    previousValue: 45,
    currentName: 'Design department',
    previousName: 'Marketing department',
  },
  {
    name: 'I can disconnect from work during my personal time',
    currentValue: 89,
    previousValue: 25,
    currentName: 'Design department',
    previousName: 'Marketing department',
  },
  {
    name: 'Stress levels in my job are manageable',
    currentValue: 65,
    previousValue: 35,
    currentName: 'Design department',
    previousName: 'Marketing department',
  },
  {
    name: 'I can manage my work responsibilities without sacrificing personal time',
    currentValue: 93,
    previousValue: 25,
    currentName: 'Design department',
    previousName: 'Marketing department',
  },
  {
    name: 'My work schedule allows me to attend important personal events',
    currentValue: 60,
    previousValue: 20,
    currentName: 'Design department',
    previousName: 'Marketing department',
  },
];

export const DECLINED_CHART_MOCK_DATA = [
  {
    name: 'My work-life balance is manageable',
    currentValue: 45,
    previousValue: 100,
    currentName: 'Marketing department',
    previousName: 'Design department',
  },
  {
    name: 'I can disconnect from work during my personal time',
    currentValue: 25,
    previousValue: 89,
    currentName: 'Marketing department',
    previousName: 'Design department',
  },
  {
    name: 'Stress levels in my job are manageable',
    currentValue: 35,
    previousValue: 75,
    currentName: 'Marketing department',
    previousName: 'Design department',
  },
  {
    name: 'I can manage my work responsibilities without sacrificing personal time',
    currentValue: 25,
    previousValue: 93,
    currentName: 'Marketing department',
    previousName: 'Design department',
  },
  {
    name: 'My work schedule allows me to attend important personal events',
    currentValue: 20,
    previousValue: 60,
    currentName: 'Marketing department',
    previousName: 'Design department',
  },
];

export const PIE_CHART_MOCK_DATA = [
  { name: 'Product department', value: 891, color: '#BEE092', id: 1 },
  { name: 'Design department', value: 751, color: '#94DCC8', id: 2 },
  { name: 'Technical department', value: 613, color: '#70C7EB', id: 3 },
  { name: 'Marketing department', value: 416, color: '#C6A1FF', id: 4 },
  { name: 'Sales department', value: 243, color: '#FF9ECC', id: 5 },
  { name: 'Executive department', value: 102, color: '#FFA67D', id: 6 },
];

export const HEATMAP_CHART_MOCK_DATA = [
  { x: 'Product', y: 'Job satisfaction', value: 0 },
  { x: 'Product', y: 'Work-Life Balance', value: 65 },
  { x: 'Product', y: 'Company Culture and Leadership', value: 22 },
  { x: 'Product', y: 'Team Dynamics', value: 5 },
  { x: 'Product', y: 'Professional Growth and Development', value: 45 },
  { x: 'Product', y: 'Innovation, Creativity, and Empowerment', value: 15 },
  { x: 'Design', y: 'Job satisfaction', value: 21 },
  { x: 'Design', y: 'Work-Life Balance', value: 55 },
  { x: 'Design', y: 'Company Culture and Leadership', value: 22 },
  { x: 'Design', y: 'Team Dynamics', value: 85 },
  { x: 'Design', y: 'Professional Growth and Development', value: 75 },
  { x: 'Design', y: 'Innovation, Creativity, and Empowerment', value: 95 },
  { x: 'Technical', y: 'Job satisfaction', value: 45 },
  { x: 'Technical', y: 'Work-Life Balance', value: 65 },
  { x: 'Technical', y: 'Company Culture and Leadership', value: 5 },
  { x: 'Technical', y: 'Team Dynamics', value: 45 },
  { x: 'Technical', y: 'Professional Growth and Development', value: 95 },
  { x: 'Technical', y: 'Innovation, Creativity, and Empowerment', value: 95 },
  { x: 'Marketing', y: 'Job satisfaction', value: 75 },
  { x: 'Marketing', y: 'Work-Life Balance', value: 20 },
  { x: 'Marketing', y: 'Company Culture and Leadership', value: 75 },
  { x: 'Marketing', y: 'Team Dynamics', value: 95 },
  { x: 'Marketing', y: 'Professional Growth and Development', value: 25 },
  { x: 'Marketing', y: 'Innovation, Creativity, and Empowerment', value: 75 },
  { x: 'Sales', y: 'Job satisfaction', value: 10 },
  { x: 'Sales', y: 'Work-Life Balance', value: 65 },
  { x: 'Sales', y: 'Company Culture and Leadership', value: 90 },
  { x: 'Sales', y: 'Team Dynamics', value: 45 },
  { x: 'Sales', y: 'Professional Growth and Development', value: 95 },
  { x: 'Sales', y: 'Innovation, Creativity, and Empowerment', value: 95 },
];
